<template>
  <div class="footer">
    <div class="foot">
      <dl>
        <dt class="fo fo1">关于我们</dt>
        <dd>
          <p><a href="/help">交易账号</a></p>
        </dd>
      </dl>
      <dl>
        <dt class="fo fo2">帮助中心</dt>
        <dd>
          <p><a href="/help">如何购买账号</a></p>
        </dd>
        <dd>
          <p><a href="/help">如何出售账号</a></p>
        </dd>
        <dd>
          <p><a href="/help">如何账号系统回收</a></p>
        </dd>
        <dd>
          <p><a href="/help">更多帮助</a></p>
        </dd>
      </dl>
      <dl>
        <dt class="fo fo3">关注我们</dt>
        <dd>
          <p><img src="./images/20220626152956_23461.png" style="width: 50%;" class="fr-fic fr-dii"></p>
        </dd>
      </dl>
      <dl>
        <dt class="fo fo4">支付方式</dt>
        <dd><p>在线支付</p></dd>
        <dd><p>银行汇款</p></dd>
        <dd><p>微信支付</p></dd>
        <dd><p>支付宝支付</p></dd>
      </dl>
      <dl>
        <dt class="fo fo5">联系我们</dt>
        <dd><p>客服电话 +63 9168888888</p></dd>
      </dl>
    </div>
    <div class="foot_text">© Suncity Group 太阳城集团. All rights reserved.</div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'v-footer',
    data () {
      return {
      }
    },
    computed: {
      ...mapState(['config_info', 'config_foot'])
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
.footer {
    background: #efefef;
    width: 100%;
    margin-top: 30px;
    border-top: solid 2px #dcdcdc;
    color: #000;
}
.foot {
    width: 1000px;
    margin: 0 auto;
    overflow: hidden;
    padding: 25px 0;
    border-bottom: solid 1px #dcdcdc;
}
.foot_text {
    text-align: center;
    line-height: 50px;
    font-size: 13px;
    color: #000;
    font-weight: 400;
}
.foot dl {
    float: left;
    width: 200px;
    font-size: 15px;
    color: #000;
}
.foot dl dt.fo {
    height: 25px;
    line-height: 25px;
    color: #000;
    font-weight: 400;
    display: flex
}
.foot dl dd p {
    font-size: 13px;
    color: #000;
    font-weight: 400;
}
.foot dl dd p a{
    color: #000;
    font-weight: 400;
}
.foot dl dd {
    margin-top: 15px;
    color: #000;
}
.fo1::before {
  content: "";
  display: inline-block;
  width: 25px;
  height: 25px;
  background: url('./images/fo_1.png') no-repeat left center;
  background-size: 100% 100%
  margin-right: 5px ; /* 調整圖片與文字之間的間距 */
}
.fo2::before {
  content: "";
  display: inline-block;
  width: 25px;
  height: 25px;
  background: url('./images/fo_2.png') no-repeat left center;
  background-size: 100% 100%
  margin-right: 5px ; /* 調整圖片與文字之間的間距 */
}
.fo3::before {
  content: "";
  display: inline-block;
  width: 25px;
  height: 25px;
  background: url('./images/fo_3.png') no-repeat left center;
  background-size: 100% 100%
  margin-right: 5px ; /* 調整圖片與文字之間的間距 */
}
.fo4::before {
  content: "";
  display: inline-block;
  width: 25px;
  height: 25px;
  background: url('./images/fo_4.png') no-repeat left center;
  background-size: 100% 100%
  margin-right: 5px ; /* 調整圖片與文字之間的間距 */
}
.fo5::before {
  content: "";
  display: inline-block;
  width: 25px;
  height: 25px;
  background: url('./images/fo_5.png') no-repeat left center;
  background-size: 100% 100%
  margin-right: 5px ; /* 調整圖片與文字之間的間距 */
}
</style>



// WEBPACK FOOTER //
// footer.vue?09b36c6a